import { render, staticRenderFns } from "./PopupExportData.vue?vue&type=template&id=e10c3fb8"
import script from "./PopupExportData.vue?vue&type=script&lang=js"
export * from "./PopupExportData.vue?vue&type=script&lang=js"
import style0 from "./PopupExportData.vue?vue&type=style&index=0&id=e10c3fb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports